import React from "react";

function Card({ src, alt, isTrumpCard, name }) {
  return (
    <div className="card">
      <img
        className={isTrumpCard ? "cardImgTrump" : "cardImg "}
        src={src}
        alt={alt}
      ></img>
      <p className={name ? "showName" : "hideName"}>{name}</p>
    </div>
  );
}

export default Card;
